import React from 'react';

import { usePermissions } from '../../hooks/usePermissions';
import ErrorState from '../common/ErrorState';

/**
 * Componente para proteger rotas baseado em permissões
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes filhos
 * @param {string} props.permission - Permissão necessária
 * @param {string} props.fallback - Componente a mostrar se não tiver permissão
 * @param {boolean} props.requireAdmin - Se requer ser admin
 * @param {string} props.requireArea - Área necessária
 */
const PermissionGuard = ({
  children,
  permission,
  fallback,
  requireAdmin = false,
  requireArea = null,
}) => {
  const { can, isAdmin, hasAreaAccess } = usePermissions();

  // Verificar se é admin (se necessário)
  if (requireAdmin && !isAdmin()) {
    return (
      fallback || (
        <ErrorState
          title="Acesso Restrito"
          description="Você precisa ser administrador para acessar esta funcionalidade."
          size="medium"
        />
      )
    );
  }

  // Verificar permissão específica
  if (permission && !can(permission)) {
    return (
      fallback || (
        <ErrorState
          title="Acesso Negado"
          description="Você não tem permissão para acessar esta funcionalidade."
          size="medium"
        />
      )
    );
  }

  // Verificar acesso à área
  if (requireArea && !hasAreaAccess(requireArea)) {
    return (
      fallback || (
        <ErrorState
          title="Acesso à Área Negado"
          description={`Você não tem acesso à área "${requireArea}".`}
          size="medium"
        />
      )
    );
  }

  return children;
};

export default PermissionGuard;
